import { createSelector } from 'reselect'
import { ReduxState } from '@/utils/typeHelpers'
import { selectOnboardingStepCompletedOrSkipped } from '@/features/onboarding/user-onboarding-steps/onboarding.selectors'
import { GettingStartedOnboardingStep } from '@/features/onboarding/user-onboarding-steps/onboarding.reducer'
import { selectIsCatchUpBookkeepingComplete } from '@/components/CatchUpBookkeepingStatus/catchUpBookkeepingStatus.selector'

export const selectNeedsMissingBankStatements = createSelector(
  (state: ReduxState) => state,
  (state) => {
    return !selectOnboardingStepCompletedOrSkipped(
      state,
      GettingStartedOnboardingStep.uploadBankStatements
    )
  }
)

export const selectNeedsUncategorizedTransactionsClarification = createSelector(
  (state: ReduxState) => state,
  (state) => {
    return !selectOnboardingStepCompletedOrSkipped(
      state,
      GettingStartedOnboardingStep.clarifyUncategorizedTransactions
    )
  }
)

export const selectPracticeOverviewAlertType = createSelector(
  selectNeedsMissingBankStatements,
  selectNeedsUncategorizedTransactionsClarification,
  selectIsCatchUpBookkeepingComplete,
  (needsBankStatements, needsTransactionClarification, isCUBKComplete) => {
    if (needsBankStatements) {
      return 'BANK_STATEMENTS'
    }

    if (needsTransactionClarification) {
      return 'CLARIFY_TRANSACTIONS'
    }

    if (!isCUBKComplete) {
      return 'CUBK_IN_PROGRESS'
    }

    return null
  }
)
